// Traduce errores del backend al rechazar una foto/captura en un mensaje accionable.
export function photoErrorInfo(e) {
  const status = e?.response?.status;
  const detail = e?.response?.data?.detail;
  const d = typeof detail === 'string' ? detail : '';
  if (!e?.response) {
    return { title: 'Sin conexión con el servidor', hint: 'Revisa tu señal e intenta de nuevo.' };
  }
  if (status === 413 || /too large|payload/i.test(d)) {
    return { title: 'La foto es demasiado pesada', hint: 'Baja la resolución de la cámara o toma la foto de nuevo y reintenta.' };
  }
  if (/EXIF|antigua|min · debe ser/i.test(d)) {
    return { title: d || 'Foto demasiado antigua (EXIF)', hint: 'La foto debe ser reciente. Toma una nueva con la cámara y reenvía.' };
  }
  if (/m de la estación|≤ 100|100 m|GPS|ubicaci/i.test(d)) {
    return { title: d || 'Ubicación fuera de rango', hint: 'Acércate a la estación (menos de 100 m), valida tu ubicación y reintenta.' };
  }
  if (/fuera de rango/i.test(d)) {
    return { title: d, hint: 'Verifica el precio en el tablero y corrige el valor antes de reenviar. Usa 0 si no hay dato.' };
  }
  if (/JSON de precios/i.test(d)) {
    return { title: 'Error en los precios ingresados', hint: 'Revisa los valores y vuelve a intentar.' };
  }
  if (status === 401 || status === 403) {
    return { title: 'Sesión expirada o sin permiso', hint: 'Cierra sesión, vuelve a entrar e intenta de nuevo.' };
  }
  if (status === 404) {
    return { title: d || 'Estación no encontrada', hint: 'Recarga la app e intenta de nuevo.' };
  }
  if (status >= 500) {
    return { title: 'Error del servidor', hint: 'Intenta en unos minutos. Si persiste, avisa al administrador.' };
  }
  return { title: d || 'Error al enviar', hint: 'Intenta de nuevo. Si persiste, avisa al administrador.' };
}
